import { Props_SnippetImageContentIcon } from './ImageContentIcon.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetImageContentIcon = (props: Props_SnippetImageContentIcon) => {
    const { heading, content, image, icon, link } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-image-content-icon__heading--${heading.visibility.value}` : ''

    return (
        <section className='snippet-image-content-icon'>
            <div className='snippet-image-content-icon__container'>
                <figure className='snippet-image-content-icon__container-image'>
                    <img
                        loading='lazy'
                        src={image.src?.value}
                        className='snippet-image-content-icon__image'
                        height='500'
                        width='1010'
                        alt={image.alt?.value ? image.alt.value : ''}
                    />
                </figure>
                <div className='snippet-image-content-icon__container-content'>
                    { icon.src?.value && (
                        <figure className='snippet-image-content-icon__container-icon'>
                            <img
                                loading='lazy'
                                src={icon.src.value}
                                className='snippet-image-content-icon__icon'
                                height='100'
                                width='100'
                                alt={icon.alt?.value || ''}
                            />
                        </figure>
                    )}
                    <h2 className={`snippet-image-content-icon__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                    { content.content?.value && <div className='snippet-image-content-icon__content'>{ Legacy_CompileMarkdown(content.content?.value)}</div> }
                    { link.linkUrl?.value && link.linkContent?.value && link.linkTarget?.value && (
                        <a
                            href={link.linkUrl.value}
                            className='snippet-image-content-icon__link attrax-button'
                            target={link.linkTarget?.value === 'true' ? '_blank' : '_self'}
                            rel='noopener noreferrer'
                        >
                            {link.linkContent?.value}
                        </a>
                    )}
                </div>
            </div>
        </section>
    )
}

export default SnippetImageContentIcon
